import { BrowserRouter, Route, Routes } from "react-router-dom";

import Layout from "./pages/Layout/Layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/AuthContext";

import Bookings from "./pages/Bookings/Bookings";
import Cars from "./pages/Cars/Cars";
import Members from "./pages/Members/Members";
import Support from "./pages/Support/Support";
import Users from "./pages/Users/Users";
import Insights from "./pages/Insights/Insights";
import BookingsManagement from "./pages/BookingsManagement/BookingsManagement";
import AddNewCar from "./pages/AddNewCar/AddNewCar";
import CarDetails from "./pages/CarDetails/CarDetails";
import UsersManagement from "./pages/UsersManagement/UsersManagement";
import Login from "./pages/Login/Login";
import ProtectedRoute from "./routes/ProtectedRoute";
function App() {

  return (
    <>
      <ToastContainer />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Protected section */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              <Route path="/bookings" element={<Bookings />} />
              <Route path="/bookings/bookings-management/:id" element={<BookingsManagement />} />
              <Route path="/cars" element={<Cars />} />
              <Route path="/cars/add-car" element={<AddNewCar />} />
              <Route path="/cars/edit-car/:id" element={<AddNewCar />} />
              <Route path="/cars/car-details/:id" element={<CarDetails />} />
              <Route path="/users" element={<Users />} />
              <Route path="/users/users-management/:id" element={<UsersManagement />} />
              <Route path="/members" element={<Members />} />
              <Route path="/support" element={<Support />} />
              <Route path="/insights" element={<Insights />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;